module.exports = __webpack_public_path__ + "img/icon-holiday.d6716656.svg";